class AccordianCustom extends HTMLElement {
    constructor() {
        super();
        this.globalAccordians = document.querySelectorAll("accordian-custom");
        this.summary = this.querySelector(".accordian_summary_cstm");
        this.content = this.querySelector(".accordian_content_cstm");
    }

    connectedCallback() {
        this.accordianToggle();
    }

    accordianToggle() {
        this.summary.addEventListener("click", () => {
            this.globalAccordians.forEach(acc => {
                if (acc !== this) {
                    acc.classList.remove("open");
                    const c = acc.querySelector(".accordian_content_cstm");
                    if(c) c.style.maxHeight = '0';
                }
            });

            if (!this.classList.contains("open")) {
                this.classList.add("open");
                this.content.style.maxHeight = this.content.scrollHeight + 10 + "px";
            } else {
                this.classList.remove("open");
                this.content.style.maxHeight = "0";
            }
        });
    }
}

if (!customElements.get("accordian-custom")) {
    customElements.define("accordian-custom", AccordianCustom);
}